<template>
  <a-card style="min-height: 30vh;">
    <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 20px">
        <span style="font-weight: bold;font-size: 16px" v-if="typeArr.includes(single.currentCode.type)">
          车位识别状态:
          <span :style="single.currentCode.parkFrame == 1?'color:blue':'color:red'">{{
              single.currentCode.parkFrame == 1 ? '已拖框' : single.currentCode.parkFrame == 0 ? '未拖框' : '未知'
            }}</span>
           <a-typography-link style="margin-left: 30px;color: red" :href="`https://beefindtech.com/webProject/mapDataEdit/bindMapCarNumber/carParking.html?buildId=${user.buildId}&floorId=${single.identityPark.floor_id}`" target="_blank">
             (打开拖框专用页)
          </a-typography-link>
        </span>
      <span v-else></span>
      <a-button @click="updateUrl" type="primary">刷新</a-button>
    </div>
    <a-spin :spinning="imageInit">
      <div style="position: relative">
        <img
            :width="640"
            :height="360"
            :src="single.currentCode.currentImageUrl"
            :preview="false"
            @load="loadImage"
        />
        <a-image :src="single.currentCode.currentImageUrl" style="display:none;" :preview="{
        visible,
        onVisibleChange: setVisible,
      }"></a-image>
        <canvas width="640" height="360" ref="canvas" id="myCanvas"></canvas>
      </div>
      <div style="margin-top: 20px;">
        <template v-if="typeArr.includes(single.currentCode.type)">
          <a-button type="primary" v-if="draw === 'save'" @click="editPark">编辑车位框</a-button>
          <a-button type="primary" v-else @click="editPark">保存车位框</a-button>
          <a-button type="primary" style="margin-left: 15px" v-if="draw !== 'save'" @click="abandonPark">放弃编辑
          </a-button>
        </template>
        <a-button type="primary" style="margin-left: 15px" @click="() => setVisible(true)">查看大图</a-button>
      </div>
      <div style="font-weight: bold;font-size: 16px;margin-top: 20px" v-if="typeArr.includes(single.currentCode.type)">
        车位小图展示:
      </div>
      <a-space style="margin-top: 20px;" v-if="typeArr.includes(single.currentCode.type)">
        <div v-for="(item,index) in emptyTable" :key="item.url"
             :style="{border:`5px dashed ${item.color}`,padding:'5px',boxSizing: 'border-box'}">
          <a-image
              :width="100"
              :src="emptyArr[index].url"
              fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
          />
        </div>
      </a-space>
      <div style="font-weight: bold;font-size: 16px;margin-top: 20px;margin-bottom: 20px"
           v-if="typeArr.includes(single.currentCode.type)">
        车位空满展示:
      </div>
      <a-table :pagination="false" :columns="emptyColumns" :data-source="emptyTable" bordered
               v-if="typeArr.includes(single.currentCode.type)">
        <template #bodyCell="{ column, record ,index}">
          <template v-if="column.key === 'km1'">
            <a-button @click="fixation(record,index,0)">固定空</a-button>
          </template>
          <template v-else-if="column.key === 'km2'">
            <a-button @click="fixation(record,index,1)">固定满</a-button>
          </template>
          <template v-else-if="column.key === 'km3'">
            <a-button @click="fix_reset()">取消固定</a-button>
          </template>
        </template>
      </a-table>
    </a-spin>
  </a-card>
</template>
<script setup>
import singleDev from "@/stores/singleDev"
import {onMounted, ref, watch} from "vue";
import {axiosGet, axiosPost} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import load from "@/common/load";
import devStore from "@/stores/devStore";
import userStore from "@/stores/user";

// 权限数组
let typeArr = ['7', '8']
let single = singleDev();
let dev = devStore();
let user = userStore();
let imageInit = ref(true)
watch(() => single.currentCode.currentImageUrl, (newValue, oldValue) => {
  console.log(newValue)
  console.log(oldValue)
  imageInit.value = true;
})
// 控制大图识别
const visible = ref(false);
const setVisible = (value) => {
  visible.value = value;
};
// 坐标备份
let filterCopy = [];
// 空满状态
let emptyArr = ref([]);
// 表头数据
let emptyColumns = ref([
  {
    title: '车位号',
    dataIndex: 'park_no',
    key: 'park_no'
  },
  {
    title: '固定空',
    dataIndex: 'km1',
    key: 'km1'
  },
  {
    title: '固定满',
    dataIndex: 'km2',
    key: 'km2'
  },
  {
    title: '取消固定',
    dataIndex: 'km3',
    customCell: (_, index) => {
      if (index === 0) {
        return {
          rowSpan: 3,
        }
      } else {
        return {
          rowSpan: 0
        }
      }
    },
    key: 'km3'
  }
]);
// 颜色
let colorArr = ['#FF3333', '#33FF33', '#3333FF', '#33FFFF', '#FF33FF', '#FFFF33'];
let points = [];
let lastPos = {x: 0, y: 0};
let pointArr = [];
let drawState = false; // 是否拖拽
let canvas = ref(null);
let emptyTable = ref([]);
let canvasContent = null;
onMounted(() => {
  canvasContent = canvas.value.getContext('2d');
  canvas.value.addEventListener('mouseup', mouseupCanvas);
  canvas.value.addEventListener('mousemove', mousemoveCanvas);
  canvas.value.addEventListener('mousedown', mousedownCanvas);
})
// 摄像头坐标转成屏幕坐标
let get_ivs_s2i = (val1, val2) => {
  let result = parseInt((val1 * val2 + (1 << 13)) >> 14);
  return result;
}

// 屏幕坐标转成摄像头
function get_s2i_ivs(val1, val2) {
  let result = parseInt(((1 << 14) * val1 / val2) + 0.5);
  return result;
}

let draw = ref('save');

// 取消固定
let fix_reset = () => {
  let msg = "";
  msg += 'echo nofixfn;';
  msg += 'uci delete firewall.@redirect[0];';
  msg += 'uci commit;';
  msg += 'cp /etc/config/firewall /root/app/firewall;';
  msg += '/etc/init.d/firewall restart;';
  msg += 'chmod +x /root/app/mips_main;';
  msg += 'killall -s 9 mips_main;';
  single.obtainTheDeviceNetworkingType('', function (topic, msg) {
    console.log(topic)
    if (msg.trim().substr(0, 7) === 'nofixfn') {
      load.success('取消固定成功！');
    }
  }, true, msg)
}
// 固定车位
let fixation = (item, park, km) => {
  park += 1;
  console.log(park, km)
  let msg = "";
  msg += 'echo fixfn;';
  msg += 'uci delete firewall.@redirect[0];';
  msg += 'uci commit;';
  msg += 'uci add firewall redirect;';
  msg += 'uci set firewall.@redirect[0]=redirect;';
  msg += "uci set firewall.@redirect[0].name='block_km_http';";
  msg += "uci set firewall.@redirect[0].proto='tcp';";
  msg += "uci set firewall.@redirect[0].src='wan';";
  msg += "uci set firewall.@redirect[0].src_dport='10080';";
  msg += "uci set firewall.@redirect[0].dest='lan';";
  msg += "uci set firewall.@redirect[0].dest_ip='192.168.121.1';";
  msg += "uci set firewall.@redirect[0].dest_port='80';";
  msg += 'uci commit;';
  msg += 'cp /etc/config/firewall /root/app/firewall;';
  msg += '/etc/init.d/firewall restart;';

  msg += 'chmod -x /root/app/mips_main;';
  msg += 'killall -s 9 mips_main;';
  msg += '/root/app/ini_tool /tmp/status/dev_info.ini dev_info km' + park + ' ' + km + ';';
  msg += '/root/app/ini_tool /tmp/status/dev_info.ini update dev_info 1;';
  single.obtainTheDeviceNetworkingType('', function (topic, msg) {
    console.log(topic)
    if (msg.trim().substr(0, 5) === 'fixfn') {
      load.success('固定成功！');
    }
  }, true, msg)
}
// 编辑车位框
let editPark = () => {
  if (draw.value === 'save') {
    draw.value = 'edit';
    startCircle()
  } else {
    load.confirm('是否保存车位框？', async () => {
      draw.value = 'save';
      canvasContent.clearRect(0, 0, canvas.value.width, canvas.value.height);
      let pointsData = {
        park_control: []
      }
      points.forEach(v => {
        v.arr = [];
        v.park_coordinates.forEach(v2 => {
          v.arr.push(get_s2i_ivs(v2.x, canvas.value.width));
          v.arr.push(get_s2i_ivs(v2.y, canvas.value.height));
        })
        pointsData.park_control.push({
          park_coordinates: v.arr,
          park_id: v.park_id
        })
        draw_Area(v);
      });
      let result = await axiosPost(api.setParkCoor.replace(/-/g, single.currentCode.qrCode), JSON.stringify(pointsData));
      if (result.result === '1') {
        load.success(result.msg);
        single.currentCode.parkFrame = 1;
        setTimeout(dev.getDevStoreList, 2000)
      } else {
        load.error(result.msg);
      }
    })
  }
}
// 放弃编辑
let abandonPark = () => {
  load.confirm('是否放弃编辑车位框？', () => {
    draw.value = 'save';
    canvasContent.clearRect(0, 0, canvas.value.width, canvas.value.height);
    console.log(filterCopy)
    filterCopy.forEach(v => {
      draw_Area(v);
    })
    points = JSON.parse(JSON.stringify(filterCopy));
    emptyTable.value = JSON.parse(JSON.stringify(filterCopy));
  })
}
let loadImage = async () => {
  console.log("图片加载完成")
  points = [];
  canvasContent.clearRect(0, 0, canvas.value.width, canvas.value.height);
  emptyArr.value = [];
  emptyTable.value = [];
  imageInit.value = false;
  if (!typeArr.includes(single.currentCode.type)) {
    return
  }
  // 坐标
  let result = await axiosGet(api.getImageCoor.replace(/-/g, single.currentCode.qrCode));
  if (result.result === '0') {
    return load.error('当前未配置该设备,没有车位框');
  }
  // 空满状态
  let result2 = await axiosGet(api.getEmptyFullStatus.replace(/-/g, single.currentCode.qrCode));
  if (result2) {
    let arr = result2.trim().split('\n').splice(8);
    console.log(arr)
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].indexOf('=') !== -1) {
        if (i === 0 || i % 6 === 0) {
          emptyArr.value.push({
            'km': arr[i].split('=')[1] === '0' ? '空' : '满',
            'url': arr[i + 5].split('=')[1],
            'plate': arr[i + 2].split('=')[1]
          })
        }
      }
    }
  }
  // 处理坐标
  result.dev_param.park_control.forEach((v, index) => {
    let {park_coordinates, park_id, park_no} = v;
    for (let i = 0; i < v['park_coordinates'].length; i++) {
      if (i % 2 === 0) {
        park_coordinates[i] = get_ivs_s2i(v['park_coordinates'][i], canvas.value.width)
      } else {
        park_coordinates[i] = get_ivs_s2i(v['park_coordinates'][i], canvas.value.height)
      }
    }
    let obj = [
      {x: park_coordinates[0], y: park_coordinates[1]},
      {x: park_coordinates[2], y: park_coordinates[3]},
      {x: park_coordinates[4], y: park_coordinates[5]},
      {x: park_coordinates[6], y: park_coordinates[7]},
    ];
    points[index] = {
      km: emptyArr.value[index]['km'],
      plate: emptyArr.value[index]['plate'],
      park_coordinates: obj,
      park_no,
      park_id,
      color: colorArr[index],
      show: true,
      type: 's'
    }
  })
  console.log(points)

  single.setParkNumber(result.dev_param);

  emptyTable.value = JSON.parse(JSON.stringify(points));

  filterCopy = JSON.parse(JSON.stringify(points));
  points.forEach(v => {
    draw_Area(v);
  });
}
let draw_Area = (pointObj) => {
  if (!pointObj.show) {
    return;
  }
  canvasContent.beginPath();
  canvasContent.lineWidth = 2;
  canvasContent.strokeStyle = pointObj.color;
  canvasContent.font = '30px "微软雅黑"';
  canvasContent.fillStyle = pointObj.color;
  canvasContent.shadowColor = '#fff';
  canvasContent.shadowBlur = 10;
  if (pointObj.type === 'x') {
    canvasContent.setLineDash([8, 8]);
  } else if (pointObj.type === 's') {
    canvasContent.setLineDash([]);
  }
  canvasContent.moveTo(pointObj.park_coordinates[pointObj.park_coordinates.length - 1].x, pointObj.park_coordinates[pointObj.park_coordinates.length - 1].y);
  for (let i = 0; i < pointObj.park_coordinates.length; i++) {
    canvasContent.lineTo(pointObj.park_coordinates[i].x, pointObj.park_coordinates[i].y);
  }
  canvasContent.closePath();
  canvasContent.stroke();
  canvasContent.fillText(pointObj.park_no, pointObj.park_coordinates[0].x + 10, pointObj.park_coordinates[0].y + 30);
  canvasContent.fillText(pointObj.km, pointObj.park_coordinates[1].x - 40, pointObj.park_coordinates[1].y + 30);
  canvasContent.fillText(pointObj.plate, pointObj.park_coordinates[3].x + 10, pointObj.park_coordinates[3].y);
};
let startCircle = () => {
  points.forEach((v, i) => {
    pointArr[i] = [];
    v.park_coordinates.forEach(v2 => {
      pointArr[i].push([v2.x, v2.y]);
      drawCircle(v2.x, v2.y, v.color);
    });
  });
};
let drawCircle = (x, y, color) => {
  canvasContent.beginPath();
  canvasContent.arc(x, y, 7, 0, 2 * Math.PI);
  canvasContent.fillStyle = color;
  canvasContent.fill();
  canvasContent.closePath();
};

let drawType = "";
let index = 0;
let index_i = 0;
function isPointInPolygon(x, y, polygon) {
  let poly = polygon.map(p => ({x: p[0], y: p[1]}));
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    let xi = poly[i].x, yi = poly[i].y;
    let xj = poly[j].x, yj = poly[j].y;
    let intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}
// 鼠标移动方法
let mousemoveCanvas = (event) => {
  let {offsetX: x, offsetY: y} = event;
  if (drawState && draw.value === 'edit') {
    if (drawType === "single") {
      if (x >= 0 && x <= canvas.value.width && y >= 0 && y <= canvas.value.height) {
        points[index]['park_coordinates'][index_i].x = x;
        points[index]['park_coordinates'][index_i].y = y;
      }
    } else if (drawType === "multiple") {
      let dx = x - lastPos.x;
      let dy = y - lastPos.y;
      let validMove = true;
      points[index]['park_coordinates'].forEach(v => {
        if (v.x + dx < 0 || v.x + dx > canvas.value.width || v.y + dy < 0 || v.y + dy > canvas.value.height) {
          validMove = false;
        }
      });
      if (validMove) {
        points[index]['park_coordinates'].forEach(v => {
          v.x += dx;
          v.y += dy;
        });
        lastPos.x = x;
        lastPos.y = y;
      }
    }
    canvasContent.clearRect(0, 0, canvas.value.width, canvas.value.height);
    points.forEach(v => {
      draw_Area(v);
    });
    startCircle();
  } else {
    drawType = "";
    for (let i = 0; i < pointArr.length; i++) {
      for (let j = 0; j < pointArr[i].length; j++) {
        if (pointInCircle(pointArr[i][j][0], pointArr[i][j][1], 7, x, y)) {
          index = i;
          index_i = j;
          drawType = 'single';
          break;
        }
        if (isPointInPolygon(x, y, pointArr[i])) {
          index = i;
          drawType = 'multiple';
          break;
        }
      }
    }
  }
}

//鼠标按下方法
let mousedownCanvas = (e) => {
  drawState = true;
  lastPos.x = e.offsetX;
  lastPos.y = e.offsetY;
}

// 鼠标松开事件
let mouseupCanvas = () => {
  drawState = false;
  drawType = "";
}


function pointInCircle(x_c, y_c, r, x_p, y_p) {
  return Math.sqrt((x_p - x_c) ** 2 + (y_p - y_c) ** 2) <= r;
}

// 刷新图片
let updateUrl = function () {
  single.currentCode.currentImageUrl = single.currentCode.currentImageUrl + new Date().getTime();
}
</script>
<style lang="scss">
#myCanvas {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
